import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './page-not-found.component.html',
    // styleUrls: ['./page-not-found.css']
})
export class PageNotFoundComponent {}


// WEBPACK FOOTER //
// ./src/app/Shared/PageNotFound/page-not-found.component.ts